<template>
    <div class="panel-footer no-print">
        <div class="input-group">
            <select class="btn btn-default btn-sm" v-model="query.limit" :disabled="loading"
                @change="updateLimit()">
                <option>5</option>
                <option>10</option>
                <option>15</option>
                <option>25</option>
                <option>50</option>
                <option>100</option>
                <option>150</option>
                <option>300</option>
                <option>500</option>
            </select>
            <small><span v-show="!is_mobile">&nbsp;Mostrando</span> {{collection.from}} - {{collection.to}} de
                {{collection.total}} <span v-show="!is_mobile">registros.</span></small>
        </div>
        <div>
            <router-link v-if="showLinkDeleted" class="btn btn-sm" :to="{ name: `${model}Deleted`}">
                <i class="fa fa-trash"></i>
                {{$t('words.deleted')}}
            </router-link>
            <button type="button" class="btn btn-sm" :disabled="collection.current_page == 1 || loading"
                @click="prevPage()">
                <span class="visible-md visible-lg">&laquo; Anterior</span>
                <span class="visible-sm visible-xs">&laquo;</span>
            </button>
            <button type="button" class="btn btn-sm" :disabled="collection.current_page == collection.last_page || loading"
                @click="nextPage()">
                <span class="visible-md visible-lg">Próximo &raquo;</span>
                <span class="visible-sm visible-xs">&raquo;</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            model: String,
            showLinkDeleted: Boolean,
            query: Object,
            loading: Boolean,
            collection: Object
        },
        computed: {
            is_mobile() {
                const isMobile = window.matchMedia('only screen and (max-width: 760px)');
                return isMobile.matches ? true : false;
            }
        },
        methods: {
            updateLimit() {
                this.query.page = 1;
                this.$emit('applyChange');
            },
            prevPage() {
               if (this.collection.last_page >= this.collection.current_page) {
                    this.query.page = Number(this.query.page) - 1;
                    this.$emit('applyChange');
                }
            },
            nextPage() {
               if (this.collection.current_page < this.collection.last_page) {
                    this.query.page = Number(this.query.page) + 1;
                    this.$emit('applyChange');
                }
            }
        }
    }
</script>